import { render, staticRenderFns } from "./EditAddPrivilegeInfo.vue?vue&type=template&id=26ca86f2&scoped=true&"
import script from "./EditAddPrivilegeInfo.vue?vue&type=script&lang=js&"
export * from "./EditAddPrivilegeInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditAddPrivilegeInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditAddPrivilegeInfo.vue?vue&type=style&index=1&id=26ca86f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ca86f2",
  null
  
)

export default component.exports